import { MutationTree } from "vuex";
import { StudyMode } from "../interfaces";
import { ClassTeachingState, InitialClassDataSnapshot, initState } from "./state";
import { OneToOneDto } from "@/services";
import { defineVuexName, MODULES } from "@/store/utils";

const mutations: MutationTree<ClassTeachingState> = {
  //setSessionInfo
  [defineVuexName(MODULES.CLASS_TEACHING.COMMITS.SET_SESSION_INFO)](
    state: ClassTeachingState,
    payload: { sessionId: string; groupId: string; classId: string },
  ): void {
    Object.assign(state, payload);
  },
  //endClass
  [defineVuexName(MODULES.CLASS_TEACHING.COMMITS.END_CLASS)](state: ClassTeachingState): void {
    Object.assign(state, initState());
  },
  //setMode
  [defineVuexName(MODULES.CLASS_TEACHING.COMMITS.SET_MODE)](state: ClassTeachingState, payload: StudyMode) {
    state.mode = payload;
  },
  //setIndependentModeCurrentUnit
  [defineVuexName(MODULES.CLASS_TEACHING.COMMITS.SET_INDEPENDENT_MODE_CURRENT_UNIT)](state: ClassTeachingState, payload: number | null) {
    state.independentModeCurrentUnit = payload;
  },
  //setIndependentModeCurrentLesson
  [defineVuexName(MODULES.CLASS_TEACHING.COMMITS.SET_INDEPENDENT_MODE_CURRENT_LESSON)](state: ClassTeachingState, payload: number | null) {
    state.independentModeCurrentLesson = payload;
  },
  //setOneToOneWithHelperIgnoreTeacherVoice
  [defineVuexName(MODULES.CLASS_TEACHING.COMMITS.SET_ONE_TO_ONE_WITH_HELP_IGNORE_TEACHER_VOICE)](state: ClassTeachingState, ignore: boolean) {
    state.oneToOneWithHelperIgnoreTeacherVoice = ignore;
  },
  [defineVuexName(MODULES.CLASS_TEACHING.COMMITS.SET_INITIAL_ONE_TO_ONE_DATA)](state: ClassTeachingState, payload: null | OneToOneDto) {
    state.initialOneToOneData = payload;
  },
  [defineVuexName(MODULES.CLASS_TEACHING.COMMITS.SET_INITIAL_CLASS_DATA_SNAPSHOT)](state: ClassTeachingState, payload: InitialClassDataSnapshot) {
    state.initialClassDataSnapshot = payload;
  },
  [defineVuexName(MODULES.CLASS_TEACHING.COMMITS.SET_IS_SOCKET_ATTEMPTED_RECONNECTING)](state: ClassTeachingState, payload: boolean) {
    state.isSocketAttemptedReconnecting = payload;
  },
  [defineVuexName(MODULES.CLASS_TEACHING.COMMITS.SET_IS_INIT_CLASS_FAILED)](state: ClassTeachingState, payload: boolean) {
    state.isInitClassFailed = payload;
  },
  [defineVuexName(MODULES.CLASS_TEACHING.COMMITS.SET_IS_RESTORING_SESSION_STATE)](state: ClassTeachingState, payload: boolean) {
    state.isRestoringSessionState = payload;
  },
};

export default mutations;
